import Grid from '@material-ui/core/Grid';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import React, { useState, useEffect } from 'react';

// ui reflection of file view
function DropdownField(props) {
  const { field, value, handleChangeWithParams, disabled } = props;
  const [currentValue, setCurrentValue] = useState(
    value && field.valueField ? field.enum.find((s) => s[field.valueField] === value) : value
  );

  useEffect(() => {
    if (field && field.name === 'status' && value && value.selected) {
      // eslint-disable-next-line no-unused-expressions
      value.selected.data.status === 0 ? setCurrentValue('INACTIVE') : setCurrentValue('ACTIVE');
    } else if (currentValue !== value) {
      setCurrentValue(field.valueField ? field.enum.find((s) => s[field.valueField] === value) : value);
    }
    // eslint-disable-next-line
  }, [field, value, setCurrentValue]);

  const handleValueChange = (e) => {
    setCurrentValue(e.target.value);
    handleChangeWithParams(field.name, field.valueField ? e.target.value[field.valueField] : e.target.value);
  };

  const itemRender = (li) => {
    const itemChildren = <span>{li.props.children === 'DEFAULT' ? 'MEMBER' : li.props.children}</span>;
    return React.cloneElement(li, li.props, itemChildren);
  };

  return (
    <Grid item xs={12}>
      <DropDownList
        label={field.label || field.name}
        name={field.name}
        data={field.enum || field.options || []}
        onChange={handleValueChange}
        required={field.required}
        style={{ width: '100%' }}
        value={currentValue || null}
        itemRender={itemRender}
        disabled={disabled || field.disabled || field.readOnly}
        textField={field.labelField}
        dataItemKey={field.itemKey}
        defaultItem={field.defaultItem}
      />
    </Grid>
  );
}

export default DropdownField;
